export const language = {
  language: 'ru',
};
